// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Vb_wa","sizeLarge":"Button_sizeLarge__MI_KT","containedSecondary":"Button_containedSecondary__2klZx","outlinedSecondary":"Button_outlinedSecondary__cRcCk"};